export default () => {
    for (const nav of document.querySelectorAll('.side-nav')) {
        const toggle = nav.querySelector('.side-nav__toggle')
        const caret = nav.querySelector('.side-nav__caret')

        if (!toggle) continue

        toggle.addEventListener('click', () => {
            const expanded = nav.classList.toggle('side-nav--expanded')
            toggle.setAttribute('aria-expanded', expanded.toString())
            if (caret) {
                caret.textContent = expanded ? 'expand_less' : 'expand_more'
            }
        })
    }
}
